import type { StoreDetailsTab } from '../../../types/features/storeDetails/page';

export const isValidStoreDetailsTab = (value: string | null): value is StoreDetailsTab =>
    value === 'overview'
    || value === 'audits'
    || value === 'users'
    || value === 'onboarding'
    || value === 'manual_entries'
    || value === 'store_locations'
    || value === 'lotto_reco_console'
    || value === 'case_simulator'
    || value === 'sales_receipts'
    || value === 'email_pipeline'
    || value === 'notifications';
